/// <reference path='../_all.ts' />

module training {

  
  export class TrainingService implements ITrainingService {
    static $inject = ['$http'];

    constructor(
      private $http: ng.IHttpService
    ) { }

    public loadTrainings(hl?: ILanguageInfo): ng.IHttpPromise<TrainingServiceData> {

      return this.$http<TrainingServiceData>({
        method: "GET" 
        , url: "/api/" + (hl || pglob.RouteData.CurrentLanguage).hl + "/Training/"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
        }
      }).then((response) => {
        if(!response.data || !response.data.Trainings) return response;
        response.data.Trainings.forEach((t) => {
          if (t.RegClosing) t.RegClosing = new Date(<any>t.RegClosing); //we recieve that as string, have to convert it.
          if (t.EndDate) t.EndDate = new Date(<any>t.EndDate); //we recieve that as string, have to convert it.
          if (t.StartDate) t.StartDate = new Date(<any>t.StartDate); //we recieve that as string, have to convert it.
        })
        return response;
      });

    }


    public registerTraining(model : TrainingFormData, trainingId : number, hl?: ILanguageInfo): ng.IHttpPromise<void> {

      return this.$http<void>({
        method: "POST" 
        , url: "/api/" + (hl || pglob.RouteData.CurrentLanguage).hl + "/Training/Register"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
          trainingId : trainingId,
        }
        , data : model
      })

    }


  }

}